<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-divider orientation="left">基础信息</a-divider>
        <a-row>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市场名称" hasFeedback>
              <a-input
                autocomplete="off"
                placeholder="请输入市场名称(项目)"
                id="name"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true
                                                  , message: '请输入市场名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="市场类型" hasFeedback>
              <a-select
                placeholder="请选择市场类型"
                id="type"
                allowClear
                :disabled="!isEdit"
                v-decorator="['type', { rules: [{ required: true, message: '请选择市场类型！' }] }]"
              >
                <a-select-option v-for="(item, index) in marketTypeList" :key="index" :value="item.code">{{ item.name }}</a-select-option>
                <!-- <a-select-option :value="1">纯软件</a-select-option>
                <a-select-option :value="2">项目集成</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预估概算" hasFeedback>
              <a-input-number
                placeholder="请输入预估概算"
                id="estimatedBudget"
                :disabled="!isEdit"
                style="width:256px"
                autocomplete="off"
                v-decorator="['estimatedBudget', { rules: [{ required: false
                                                             , message: '请输入预估概算！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="预估毛利" hasFeedback>
              <a-input-number
                placeholder="请输入预估毛利"
                id="estimatedOutput"
                style="width:256px"
                :disabled="!isEdit"
                v-decorator="['estimatedOutput', { rules: [{ required: false
                                                             , message: '请输入预估毛利！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" hasFeedback>
              <a-select
                :disabled="!isEdit"
                style="width: 256px"
                :allowClear="true"
                placeholder="请选择负责人"
                v-decorator="['leaderId', { rules: [{ required: false
                                                      , message: '请选择负责人！' }] }]"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in userList"
                  :key="index"
                >{{ item.userName }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="创建日期" hasFeedback>
              <a-date-picker
                :disabled="!isEdit"
                style="width:256px"
                @change="onChange"
                placeholder="请选择创建日期"
                v-decorator="['createTime', { rules: [{ required: false
                                                        , message: '请选择创建日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地区" hasFeedback>
              <a-cascader
                :options="areaList"
                placeholder="请选择地区"
                id="area"
                :disabled="!isEdit"
                @change="changArea"
                v-decorator="['area', { rules: [{ required: false
                                                  , message: '请选择地区！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="跟进状态" hasFeedback>
              <a-select
                :disabled="!isEdit"
                style="width: 256px"
                placeholder="请选择状态"
                v-decorator="['status', { rules: [{ required: false
                                                    , message: '请选择状态！' }] }]"
              >
                <a-select-option
                  :value="item.code"
                  v-for="(item,index) in statusList"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-divider orientation="left">业主信息</a-divider>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="业主单位" hasFeedback>
              <a-select
                :disabled="!isEdit"
                style="width: 256px"
                @change="changProprietor"
                placeholder="请选择业主单位"
                :allowClear="true"
                v-decorator="['proprietorId', { rules: [{ required: false
                                                          , message: '请选择业主单位！' }] }]"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item,index) in proprietorList"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" hasFeedback>
              <a-select
                :disabled="!isEdit"
                style="width: 256px"
                @change="changProprietorContact"
                placeholder="请选择联系人"
                v-decorator="['proprietorContactId', { rules: [{ required: false
                                                                 , message: '请选择联系人！' }] }]"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item,index) in proprietorContactsList"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话" hasFeedback>
              <a-input
                placeholder="请输入联系人电话"
                id="proprietorContactPhone"
                :disabled="true"
                autocomplete="off"
                v-decorator="['proprietorContactPhone']"
              />
            </a-form-item>
          </a-col>
          <a-divider orientation="left">设计代表</a-divider>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设计代表" hasFeedback>
              <a-select
                :disabled="!isEdit"
                style="width: 256px"
                @change="changDesign"
                :allowClear="true"
                placeholder="请选择设计代表"
                v-decorator="['designId', { rules: [{ required: false
                                                      , message: '请选择设计代表！' }] }]"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item,index) in designList"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" hasFeedback>
              <a-select
                :disabled="!isEdit"
                style="width: 256px"
                @change="changDesignContact"
                placeholder="请选择联系人"
                v-decorator="['designContactId', { rules: [{ required: false
                                                             , message: '请选择联系人！' }] }]"
              >
                <a-select-option
                  :value="item.id"
                  v-for="(item,index) in designContactsList"
                  :key="index"
                >{{ item.name }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话" hasFeedback>
              <a-input
                placeholder="请输入联系人电话"
                id="designContactPhone"
                :disabled="true"
                autocomplete="off"
                v-decorator="['designContactPhone']"
              />
            </a-form-item>
          </a-col>
          <a-divider orientation="left">招标代理</a-divider>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="招标代理" hasFeedback>
              <a-input
                placeholder="请输入招标代理"
                id="biddingAgent"
                :disabled="!isEdit"
                autocomplete="off"
                v-decorator="['biddingAgent', { rules: [{ required: false
                                                          , message: '请输入招标代理！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人" hasFeedback>
              <a-input
                placeholder="请输入联系人"
                id="biddingContact"
                :disabled="!isEdit"
                autocomplete="off"
                v-decorator="['biddingContact', { rules: [{ required: false
                                                            , message: '请输入联系人！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="电话" hasFeedback>
              <a-input
                placeholder="请输入联系人电话"
                id="biddingPhone"
                :disabled="!isEdit"
                autocomplete="off"
                v-decorator="['biddingPhone', { rules: [{ required: false
                                                          , message: '请输入联系人电话！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-divider orientation="left">附件</a-divider>
          <a-col :span="22">
            <!-- <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="文件上传">
              <uploader
                ref="uploader"
                v-if="isEdit"
                :showUploadList="false"
                @handleUpload="handleUpload"
              ></uploader>
              <div v-for="item in fileList" :key="item.id" class="downloadFileList">
                <p>
                  {{ item.fileName }}
                  <a-icon type="download" v-if="item.id" @click="handleDownload(item)" />
                  <a-icon type="eye" v-if="item.id" @click="handlePreview(item)" />
                  <a-popconfirm
                    :title="'你确定要删除“' + item.fileName + '”吗?'"
                    @confirm="handleDeleteFile(item)"
                    v-if="type !== 'MODAL_VIEW'"
                  >
                    <a-icon type="delete" />
                  </a-popconfirm>
                </p>
              </div>
            </a-form-item> -->
            <a-form-item v-if="isEdit" :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="文件上传">
              <zm-upload
                ref="uploader"
                title="上传"
                :baseUrl="$sysInfo.apiRemote"
                :headers="headers"
                :list="fileList"
                @handleUpload="handleUpload"
              ></zm-upload>
            </a-form-item>
            <a-form-item v-if="!isEdit" :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="附件">
              <zm-preview
                :list="fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/market/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>
          <a-col :span="24" style="margin-top: 10px; text-align: right">
            <a-button
              type="primary"
              html-type="submit"
              style="margin-right:10px;"
              v-if="this.type !== this.$sysInfo.MODAL_VIEW"
            >提交</a-button>
            <!--            <a-button style="margin-right:10px;" @click="cancel">取消</a-button>-->
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import moment from 'moment'
// import Uploader from '@/CrComponents/Uploader'
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { getContactsById, getDesignContactsById } from '@/api/contacts.js'
import { insertMarkets, updateMarkets } from '@/api/markets'
import { mapActions, mapGetters } from 'vuex'
// import { downLoadFile } from '@/api/download'
// import { addressOptions } from '@/utils/proviceData.js'
export default {
  name: 'EditMarkets',
  mounted () {
    this.initArea()
  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    proprietorList () {
      return this.$store.state.market.proprietorList
    },
    designList () {
      return this.$store.state.market.designList
    },
    userList () {
      return this.$store.state.market.userList
    },
    statusList () {
      return this.$store.state.market.statusList
    },
    ...mapGetters(['marketTypeList'])
  },
  components: {
    baseModal,
    // Uploader
  },
  data () {
    return {
      fileList: [], // 默认上传文件
      // addressOptions:null,
      title: '操作',
      width: 1200,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'markets' }),
      visible: false,
      defaultModel: {},
      model: {},
      headers: {
        Authorization: this.$store.state.user.token
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      areaList: [],
      proprietorContactsList: [], // 业主联系人列表
      designContactsList: [], // 设计代表联系人列表
      provinceId: null,
      cityId: null,
      districtId: null,
      files: []
    }
  },
  methods: {
    // ...mapActions(['handleGetAreaList']),
    // 初始化地区
    // initArea () {
    //   this.handleGetAreaList().then((res) => {
    //     // console.log('地区数据', res)
    //     this.areaList = res
    //   })
    // },
    // 获取leader

    // 切换时间
    onChange () {},
    // 切换设计代表
    changDesign (value) {
      this.form.setFieldsValue({
        designContactId: null,
        designContactPhone: null
      })
      getDesignContactsById(value).then((res) => {
        if (res.status === 0) {
          this.designContactsList = res.data
        }
      })
    },
    // 切换业主
    changProprietor (value) {
      this.form.setFieldsValue({
        proprietorContactId: null,
        proprietorContactPhone: null
      })
      getContactsById(value).then((res) => {
        if (res.status === 0) {
          this.proprietorContactsList = res.data
        }
      })
    },
    // 切换业主联系人
    changProprietorContact (value) {
      const list = this.proprietorContactsList
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === value) {
          this.form.setFieldsValue({
            proprietorContactPhone: list[i].phone1
          })
          break
        }
      }
    },
    // 切换代表联系人
    changDesignContact (value) {
      const list = this.designContactsList
      for (let i = 0; i < list.length; i++) {
        if (list[i].id === value) {
          this.form.setFieldsValue({
            designContactPhone: list[i].phone1
          })
          break
        }
      }
    },
    // 选择地区
    changArea (value) {
      // value[0],value[1],value[2]
      if (value.length === 2) {
        // 省市自治区
        this.provinceId = value[0]
        this.cityId = value[1]
      } else {
        this.provinceId = value[0]
        this.cityId = value[1]
        this.districtId = value[2]
      }
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.$nextTick(() => {
        // console.log(JSON.stringify(model))
        this.model = Object.assign({}, model)
        this.fileList = [...this.model.files]
        this.form.setFieldsValue({
          id: this.model.id,
          status: this.model.status,
          name: this.model.name,
          type: this.model.type,
          biddingAgent: this.model.biddingAgent,
          biddingContact: this.model.biddingContact,
          biddingPhone: this.model.biddingPhone,
          cityId: this.cityId,
          createTime: moment(this.model.createTime, 'YYYY-MM-DD').utc(8),
          designContactId: this.model.designContactId,
          designId: this.model.designId,
          designContactPhone: this.model.designContactPhone,
          districtId: this.districtId,
          area: [this.model.provinceId, this.model.cityId, this.model.districtId],
          estimatedBudget: this.model.estimatedBudget,
          estimatedOutput: this.model.estimatedOutput,
          statusName: this.model.statusName,
          leaderName: this.model.leaderName,
          leaderId: this.model.leaderId,
          proprietorContactId: this.model.proprietorContactId,
          proprietorContactPhone: this.model.proprietorContactPhone,
          proprietorId: this.model.proprietorId,
          provinceId: this.provinceId
        })
        // 编辑的状态下 1.获取业主单位id 2.调用方法changProprietor（value）
        if (this.model.designId) {
          const designId = this.model.designId
          this.changDesign(designId)
          if (this.model.designContactId) {
            this.form.setFieldsValue({
              designContactId: this.model.designContactId,
              designContactPhone: this.model.designContactPhone
            })
          }
        }
        if (this.model.proprietorId) {
          const proprietorId = this.model.proprietorId
          this.changProprietor(proprietorId)
          if (this.model.proprietorContactId) {
            this.form.setFieldsValue({
              proprietorContactId: this.model.proprietorContactId,
              proprietorContactPhone: this.model.proprietorContactPhone
            })
          }
        }
      })
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        if (this.type === 'MODAL_ADD') {
          console.log('this.$store.user', this.$store)
          this.$nextTick(() => {
            this.form.setFieldsValue({
              leaderId: this.$store.getters.userId,
              createTime: moment(new Date(), 'YYYY-MM-dd')
            })
          })
        }
      }
      this.$nextTick(() => {
        if (!flag) {
          this.model.id = null
        }
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...this.model, ...value }
          console.log(this.fileList)
          params.files = this.fileList

          params.provinceId = this.provinceId
          params.cityId = this.cityId
          params.districtId = this.districtId
          if (this.type === this.$sysInfo.MODAL_ADD) {
            if (params.id) delete params.id
            insertMarkets(params).then((res) => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          } else if (this.type === this.$sysInfo.MODAL_MODIFY) {
            updateMarkets(params).then((res) => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('refreshTable')
                this.open(false)
              } else {
                this.$message.error(res.info.message)
              }
            })
          }
        }
      })
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
      this.model = {}
      this.fileList = []
      if (this.$refs.uploader) this.$refs.uploader.clearFileList()
      // setTimeout(() => {
      //   this.$refs.uploader.clearFileList()
      // })
    },
    cancel () {
      this.formClear()
      this.open(false)
    },
    handleUpload (fileList) {
      this.fileList = fileList
      // fileList.map((item) => {
      //   this.fileList.push(item)
      // })

      // this.$refs.uploader.clearFileList()
    },
    // handleDownload (item) {
    //   var urlPath = `/opt/pms/back/dataSystem/market/` + item.filePath
    //   // return
    //   downLoadFile(urlPath).then((res) => {
    //     const blob = new Blob([res])
    //     const downloadElement = document.createElement('a') // 创建下载的链接
    //     const href = window.URL.createObjectURL(blob)
    //     downloadElement.href = href
    //     downloadElement.download = item.fileName // 下载后的文件名
    //     document.body.appendChild(downloadElement)
    //     downloadElement.click() // 下载
    //     document.body.removeChild(downloadElement) // 下载完成 移除 a
    //     window.URL.revokeObjectURL(href) // 释放blob对象
    //   })
    // },
    // // 删除文件
    // handleDeleteFile (file) {
    //   const dataSource = [...this.fileList]
    //   this.fileList = dataSource.filter((item) => item.filePath !== file.filePath)
    //   console.log('cececes', this.fileList)
    // },
    // handlePreview (item) {
    //   console.log('预览', item)
    //   var filePath = '/opt/pms/back/dataSystem/market/' + item.filePath
    //   window.open(
    //     `${this.$sysInfo.previewUrl}` +
    //       filePath +
    //       `&fileName=${item.filePath}` +
    //       `&account=${this.$store.state.user.info.account}` +
    //       `&token=${this.$store.state.user.info.token}` +
    //       '&jwtToken=' +
    //       this.$store.state.user.token
    //   )
    // }
    // 获取select列表
  }
}
</script>

<style scoped lang="less">
.downloadList {
  margin-top: 10px;
  list-style: none;
  li {
    margin: 10px;
  }
}
</style>
